"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USA = void 0;
const phone_utils_1 = require("./phone.utils");
const phone_constants_1 = require("./phone.constants");
exports.USA = {
    Utils: phone_utils_1.Utils,
    CONSTANTS: phone_constants_1.CONSTANTS,
};
//# sourceMappingURL=index.js.map